import React from 'react';
import {Trans} from 'react-i18next';
import {Field} from 'formik';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import Section from '../../layout/Section';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import _get from 'lodash/get';

export default function CurrencySymbolForPrice({formikProps}) {
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.common.currency.symbol.for.price">
          Currency Symbol for Price
        </Trans>
      }
    >
      <p className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.common.currency.symbol.for.price.desc">
          Choose whether to display the currency symbol with prices (e.g.,
          "$1,000" vs. "1,000") in the Skincare Pro application.
        </Trans>
      </p>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.common.currency.symbol.for.price.show.product">
            Show Currency Symbol for Skincare Product
          </Trans>
        }
      >
        <div className="col-5">
          <Field
            name="currencySymbol.enableSkincareProduct"
            value={_get(formikProps.values, 'currencySymbol.enableSkincareProduct', true)}
            component={CustomSwitch}
          />
        </div>
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.common.currency.symbol.for.price.show.treatment">
            Show Currency Symbol for Skincare Treatment
          </Trans>
        }
      >
        <div className="col-5">
          <Field
            name="currencySymbol.enableSkincareTreatment"
            value={_get(formikProps.values, 'currencySymbol.enableSkincareTreatment', true)}
            component={CustomSwitch}
          />
        </div>
      </LeftTitleWithField>
    </Section>
  );
}
